import { PluginExtension } from '@/types/pluginExtension';

/**
 * マニュアルの URL を取得する関数
 * @param {PluginExtension} $pluginExtension - プラグイン拡張情報
 * @returns {string | null} マニュアルの URL、または null（Lite や kenpon の場合）
 *
 * @throws {Error} MHM 向けマニュアルの URL が設定されていない場合
 */
export function getManualURL({ $domain, $auth }: PluginExtension): string | null {
  const {
    user: { organization },
  } = $auth;
  if (organization.config?.disableManualUrl) {
    return null;
  }

  if (organization.config?.overrideManualUrl) {
    return organization.config.overrideManualUrl;
  }

  return 'https://faq.legalscape.jp';
}

/**
 * サポートの URL を取得する関数
 * @param {PluginExtension} $pluginExtension - プラグイン拡張情報
 * @returns {string} サポートの URL
 */
export function getSupportURL({ $auth }: PluginExtension): string {
  const {
    user: { organization },
  } = $auth;
  if (organization.config?.overrideSupportUrl) {
    return organization.config.overrideSupportUrl;
  }

  return 'https://faq.legalscape.jp/kb-tickets/new';
}
